import { c as _c } from "react/compiler-runtime";
import { ROUTES } from "@/utils/constants";
import Head from "next/head";
import { useRouter } from "next/router";
const SITE_NAME = "Dimitar Daskalov";
const SITE_DESCRIPTION = "Explore my portfolio and projects.";
const OG_IMAGE = "https://portfolio-v2-ten-beige.vercel.app/preview.png";
interface SEOData {
  title: string;
  description: string;
  noindex?: boolean;
}
const SEO_DATA: Record<string, SEOData> = {
  [ROUTES.HOME]: {
    title: "Home",
    description: SITE_DESCRIPTION
  },
  [ROUTES.SECRET]: {
    title: "Secret",
    description: SITE_DESCRIPTION
  },
  [ROUTES.NOT_FOUND]: {
    title: "404",
    description: SITE_DESCRIPTION,
    noindex: true
  },
  [ROUTES.OFFLINE]: {
    title: "Offline",
    description: "This page isn't available without a connection.",
    noindex: true
  }
};
const getCanonicalUrl = () => {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.href;
};
export const SEO = () => {
  const $ = _c(30);
  const router = useRouter();
  const path = router.pathname;
  const data = SEO_DATA[path] || SEO_DATA[ROUTES.NOT_FOUND];
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getCanonicalUrl();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const canonicalUrl = t0;
  const fullTitle = `${SITE_NAME} | ${data.title}`;
  let t1;
  if ($[1] !== fullTitle) {
    t1 = <title>{fullTitle}</title>;
    $[1] = fullTitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== data.description) {
    t2 = <meta name="description" content={data.description} />;
    $[3] = data.description;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = canonicalUrl && <link rel="canonical" href={canonicalUrl} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== data.noindex) {
    t4 = data.noindex && <meta name="robots" content="noindex, nofollow" />;
    $[6] = data.noindex;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <meta property="og:type" content="website" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== fullTitle) {
    t6 = <meta property="og:title" content={fullTitle} />;
    $[9] = fullTitle;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== data.description) {
    t7 = <meta property="og:description" content={data.description} />;
    $[11] = data.description;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <meta property="og:image" content={OG_IMAGE} />;
    t9 = <meta property="og:site_name" content={SITE_NAME} />;
    t10 = canonicalUrl && <meta property="og:url" content={canonicalUrl} />;
    t11 = <meta name="twitter:card" content="summary_large_image" />;
    $[13] = t10;
    $[14] = t11;
    $[15] = t8;
    $[16] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t8 = $[15];
    t9 = $[16];
  }
  let t12;
  if ($[17] !== fullTitle) {
    t12 = <meta name="twitter:title" content={fullTitle} />;
    $[17] = fullTitle;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== data.description) {
    t13 = <meta name="twitter:description" content={data.description} />;
    $[19] = data.description;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <meta name="twitter:image" content={OG_IMAGE} />;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t1 || $[23] !== t12 || $[24] !== t13 || $[25] !== t2 || $[26] !== t4 || $[27] !== t6 || $[28] !== t7) {
    t15 = <Head>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}</Head>;
    $[22] = t1;
    $[23] = t12;
    $[24] = t13;
    $[25] = t2;
    $[26] = t4;
    $[27] = t6;
    $[28] = t7;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};